var urlParser = {
    hash: window.location.hash.slice(1),
    get: window.location.search.slice(1),
    path: window.location.pathname.slice(1),
    init: function () {
        if (urlParser.get !== '') {
            return {
                hash: urlParser.parseGet(urlParser.hash),
                get: urlParser.parseGet(urlParser.get),
                path: urlParser.parsePath(urlParser.path)
            };
        }
        return false;
    },
    parseGet: function (part) {
        var results = part.split('&').reduce(function (result, item) {
            var parts = item.split('=');
            result[parts[0]] = parts[1];
            return result;
        }, {});

        return results;
    },
    parsePath: function (part) {
        var results = part.split('/');
        return results;
    }
};